import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * Suggested Sales (Reorder) list configuration
 * Customers due for reorder based on historical ordering patterns
 */
export const suggestedSalesList: ListBuilderList = {
	id: 'suggested-sales-list',
	cacheTTL: 600000,
	name: 'Reorder',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	columns: createClientColumnsNoLifecycle(),
	description:
		'Customers due for reorder based on historical ordering patterns',
	defaultSortId: 'forecast',
	requiredFields: [
		'client._id',
		'client.address1',
		'client.averageInvoiceRevenue',
		'client.businessType',
		'client.city',
		'client.companyNames',
		'client.email',
		'client.externalId',
		'client.externalId2',
		'client.fax',
		'client.forecastedReorderDate',
		'client.googlePlaceId',
		'client.latitude',
		'client.leadOrCustomer',
		'client.longitude',
		'client.name',
		'client.nextActivityDate',
		'client.phone',
		'client.salesStatus',
		'client.state',
		'client.zip',
	],
	filters: {
		activeFilters: ACTIVITY_LIST_ACTIVE_FILTERS,
	},
	sortOrder: 4,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		leadOrCustomer: {
			defaultValue: [
				{
					id: 'Customer',
					label: 'Customer',
				},
			],
		},
		specialFilters: {
			defaultValue: [
				{
					id: 'reorder_due',
					label: 'Reorder Due',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
